<template>
    <div>
        <div v-if="overviewInitStatus == 'LOADING'">
            <div class="text-center mb-2">
                <b-progress :value="loadingFormDataValue" show-progress class="m-5" />
            </div>
        </div>
        <div class="failedRequest" v-if="overviewInitStatus == 'FAILED'">Unable to return results due to a server error.</div>
        <div v-if="overviewInitStatus == 'LOADED'">
            <div class="overview-container">
                <div class="tables-container1">
                    <div class="tables-container2">
                        <ToplistTable
                            @onExpandColumnClick="toggleHideTable"
                            :title="staticTitleToplistOneDay"
                            :subtitle="subtitleToplistOneDay"
                            :getter="getterToplistOneDay"
                            :hideTable="hideTable"
                            :showExpandedColumns="showExpandedColumns"
                        />
                        <ToplistTable
                            v-if="this.$store.getters.getTopProgramsSevenDaysResults.data"
                            @onExpandColumnClick="toggleHideTable"
                            :title="staticTitleToplistSevenDays"
                            :subtitle="subtitleLatestSevenDays"
                            :getter="getterToplistSevenDays"
                            :hideTable="hideTable"
                            :showExpandedColumns="showExpandedColumns"
                        />
                    </div>
                    <OverviewDiagram :title="staticTitleDiagramSevenDays" :subtitle="subtitleLatestSevenDays" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ToplistTable from "@/components/Layout/Overview/ToplistTable"
import OverviewDiagram from "@/components/Layout/Overview/OverviewDiagram"
import * as ActionsOverview from "@/store/modules/overview/action-types"
import * as ActionsPrograms from "@/store/modules/programs/action-types"
import * as MutationsOverview from "@/store/modules/overview/mutation-types"
import * as MutationsPrograms from "@/store/modules/programs/mutation-types"
import * as ActionsChannels from "@/store/modules/channels/action-types"
import * as MutationsChannels from "@/store/modules/channels/mutation-types"
import globalConfig from "../../../mixins/globalConfig"
import dayjs from "dayjs"

export default {
    name: "Overview",
    components: {
        ToplistTable,
        OverviewDiagram,
    },
    mixins: [globalConfig],
    data() {
        return {
            showExpandedColumns: false,
            hideTable: false,
            loadingFormDataValue: 0,
            getterToplistOneDay: "getTopProgramsLatestDayResults",
            staticTitleToplistOneDay: "Top list of programs, 1 day",
            getterToplistSevenDays: "getTopProgramsSevenDaysResults",
            staticTitleToplistSevenDays: "Top list of programs, 7 days",
            staticTitleDiagramSevenDays: "Reach* channels, rolling 7-day period",
            latestDate: "",
            dateSixDaysAgo: "",
        }
    },
    async mounted() {
        this.init()
    },
    computed: {
        overviewInitStatus() {
            return this.$store.getters.getOverviewInitStatus
        },
        subtitleToplistOneDay() {
            return this.latestDate
        },
        subtitleLatestSevenDays() {
            return `${this.dateSixDaysAgo} - ${this.latestDate}`
        },
    },
    methods: {
        async init() {
            try {
                await this.$store.commit(MutationsOverview.setOverviewInitStatus, "LOADING")
                this.loadingFormDataValue = 0
                const [programsColumns, channelsColumns] = await Promise.all([
                    this.$store.dispatch(ActionsPrograms.getProgramsColumnTypes),
                    this.$store.dispatch(ActionsChannels.getChannelsColumnTypes),
                ])
                await this.loadGlobalConfigFromFile()

                this.loadingFormDataValue = 5
                await this.$store.commit(MutationsPrograms.setProgramsColumnTypes, programsColumns)
                this.loadingFormDataValue = 25
                await this.$store.commit(MutationsChannels.setChannelsColumnTypes, channelsColumns)
                this.loadingFormDataValue = 50
                //possible slow actions incoming, animating the progressbar
                const counter1 = setInterval(() => {
                    this.loadingFormDataValue++
                    if (this.loadingFormDataValue >= 95) clearInterval(counter1)
                }, 1600)
                await this.$store.dispatch(ActionsOverview.executeOverviewPublishedDateQuery)
                await this.$store.dispatch(ActionsOverview.executeTopProgramsLatestDayQuery)
                await this.$store.dispatch(ActionsOverview.executeTopProgramsSevenDaysQuery)
                await this.$store.dispatch(ActionsOverview.executeSitesReachSevenDaysQuery)
                this.latestDate = await this.$store.getters.getOverviewPublishedDate
                this.dateSixDaysAgo = dayjs(this.latestDate)
                    .subtract(6, "day")
                    .format("YYYY-MM-DD")
                this.loadingFormDataValue = 95
                await this.$store.commit(MutationsOverview.setOverviewInitStatus, "LOADED")
                this.loadingFormDataValue = 100
            } catch (error) {
                await this.$store.commit(MutationsOverview.setOverviewInitStatus, "FAILED")
            }
        },
        toggleHideTable() {
            this.hideTable = true
            this.showExpandedColumns = !this.showExpandedColumns
            setTimeout(() => {
                this.hideTable = false
            }, 1)
        },
    },
}
</script>

<style scoped>
.overview-container {
    background-color: white;
    display: block;
    box-sizing: border-box;
    padding: 20px 30px;
    width: 100%;
}
::v-deep .tables-container1 {
    width: 100%;
    display: flex !important;
    flex-wrap: wrap !important;
    flex-direction: column !important;
    justify-content: space-between !important;
}
::v-deep .tables-container2 {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 5rem;
}
/* expand table transitions */
.modal-enter-to,
.modal-leave {
    transition: opacity 0.35s ease-in-out;
}
.modal-enter,
.modal-leave-to {
    opacity: 0;
}
</style>
